<i
  class="mdi mdi-information-outline"
  [title]="'GLOBAL_BTN_DETAILS' | translate"
  (click)="onClick()"
></i>
